export default __webpack_public_path__ + "5859e6cff688ed2fa5ed2fdacdc4fd55.svg";